import { request } from "@/utils/remoteRequest";

// 根据职位id和用户code查询简历信息 - 简历投递时
export function getAllResumeInfoByPositionIdAndUserPhone(data) {
  return request({
    url: "/resumeInfo/searchAllResumeInfoByPositionIdAndUserPhone",
    method: "post",
    data,
  });
}

// 根据简历id查询简历信息 - 管理员查看简历时
export function getResumeInfoById(data) {
  return request({
    url: "/resumeInfo/searchResumeInfoById",
    method: "post",
    data,
  });
}

// 根据简历id查询简历信息 - 管理员查看简历时
export function getResumeInfoViewById(data) {
  return request({
    url: "/resumeInfo/searchResumeInfoViewById",
    method: "post",
    data,
  });
}

// 根据用户查询简历信息 - 菜单栏我的简历
export function getResumeInfoByUserPhone(data) {
  return request({
    url: "/resumeInfo/searchResumeInfoByUserPhone",
    method: "post",
    data,
  });
}

// 保存简历
export function saveResumeInfo(data) {
  return request({
    url: "/resumeInfo/saveAllResumeInfo",
    method: "post",
    data,
  });
}

// 简历标记为不合适
export function unSuitResume(data) {
  return request({
    url: "/postSend/unSuitResume",
    method: "post",
    data,
  });
}

// 简历取消不合适
export function suitResume(data) {
  return request({
    url: "/postSend/suitResume",
    method: "post",
    data,
  });
}

// 收藏简历
export function collectResume(data) {
  return request({
    url: "/resumeCollect/collectResume",
    method: "post",
    data,
  });
}

// 取消收藏简历
export function unCollectResume(data) {
  return request({
    url: "/resumeCollect/unCollectResume",
    method: "post",
    data,
  });
}
